import filter from 'lodash/filter';
import head from 'lodash/head';

export class CensusDataMapService {
	constructor($resource, ApiService) {
		'ngInject';

		this.$resource = $resource;
		this.apiService = ApiService;

		this.censusDataMapResourceUrl = this.apiService.getResourceUrl('menus/CensusData');
		this.censusDataFilterResourceUrl = this.apiService.getResourceUrl('menus/CensusData/filter');

		this.censusDataMapResource = this.$resource(this.censusDataMapResourceUrl);
		this.censusDataFilterResource = this.$resource(this.censusDataFilterResourceUrl);
	}

	_getOverviewDetailsObject(details) {
		return {
			contentId: details.content_id,
			menuId: details.menu_id,
			displayName: details.display_name,
			name: details.name,
			title: details.title,
			description: details.description
		}
	}

	_getYearListObject(values) {
		return values.reduce((year, data) => {
			if (data.name === 'Year') {
				year = year.concat(_getYearData.call(this, data.values));
			}
			return year;
		}, []);

		function _getYearData(data) {
			return data.map(value => ({
				id: value.fiscal_year_id,
				name: value.fiscal_year
			}));
		}
	}

	_getFilterObject(values) {
		let details = filter(values, ['name', 'filter']);
		return _getFilterData(head(details).values);

		function _getFilterData(data) {
			return data.map(value => ({
				id: value.id,
				title: value.title,
				isSelected: value.id === 1 ? true : false
			}));
		}		
	}

	_getVehiclesCountObject(value) {
		return {
			oneVehicle: parseInt(value['1_vehicle']),
			noVehicle: parseInt(value['no_vehicle'])
		}
	}

	_getCensusDataObject(values) {
		return values.reduce((censusData, data) => {
			if(data.name === 'censusData') {
				censusData.fiscalYearId = data.fiscal_year_id;
				censusData.countyData = censusData.countyData.concat(_getCensusData.call(this, data.values));
			}
			return censusData;
		}, {
			fiscalYearId : '',
			countyData : []
		});

		function _getCensusData(data) {
			return data.map(value => ({
				name: value.county_name,
				ownerOccupied: value.owner_occupied ? this._getVehiclesCountObject(value.owner_occupied) : {},
				renterOccupied: value.renter_occupied ? this._getVehiclesCountObject(value.renter_occupied) : {}
			}));
		}		
	}

	_getReferenceMapsObject(values) {
		let details = filter(values, ['name', 'referenceMap']);
		return _getMapsData(head(details).values);

		function _getMapsData(data) {
			return data.map(value => ({
				name: value.name,
				displayName: value.display_name
			}));
		}
	}

	getCensusMapData() {
		const promise = this.censusDataMapResource.get().$promise;

		return promise.then(details => ({
			menuOverviewDetails: this._getOverviewDetailsObject(details.data.menuOverviewDetails),
			fiscalYear: this._getYearListObject(details.data.content),
			filter: this._getFilterObject(details.data.content),
			censusData: this._getCensusDataObject(details.data.content),
			referenceMaps: this._getReferenceMapsObject(details.data.content)
		})).catch((error) => {
			throw this.apiService.getErrorMessage(error);
		});
	}

	getCensusFilterData(id) {
		const promise = this.censusDataFilterResource.get({fiscal_year_id: id}).$promise;

		return promise.then(details => ({censusData : this._getCensusDataObject([details.data])}))
		.catch((error) => {
			throw this.apiService.getErrorMessage(error);
		});
	}
}


// WEBPACK FOOTER //
// ./src/app/components/planning-resources-census-data/planning-resources-census-data.service.js